<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QCYv3g/tc-custom/9781684125623.jpg?1737808010652" alt="This image is the cover for the book Classic Works from Women Writers, Leather-bound Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Classic Works from Women Writers, Leather-bound Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>A fine collection of classic novels, short stories, poems, and essays from distinguished women writers.</b><br/><br/> Women writers have been making their voices heard for centuries, but their works were not always taken seriously. Over time, as women gained more social and political freedom, these works have reemerged as subjects that are considered to be worthy of closer study. <i>Classic Works from Women Writers</i> is a collection of more than thirty novels, short stories, poems, and essays by prominent and lesser-known female writers since the seventeenth century. Included in this volume are groundbreaking works such as Mary Shelley’s <i>Frankenstein</i>; Agatha Christie’s <i>The Mysterious Affair at Styles</i>, the first Hercule Poirot novel; Charlotte Perkins Gilman’s short story “The Yellow Wallpaper” and her follow-up essay; and poetry from the likes of Christina Rossetti, Amy Lowell, and Sara Teasdale. The words of these authors offer a multitude of perspectives on different issues that affect not only women but the wider world as well.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. J. Odasso
      </h2>
      
      <p class="authorDescription body article">Canterbury Classics is an imprint of Printers Row Publishing Group, a wholly owned subsidiary of Readerlink Distribution Services, LLC, the largest full-service book distributor to non-trade booksellers in North America. Canterbury Classics publishes classic works of literature in fresh, modern formats. From elegant leather-bound editions to whimsical pop-up books to the best-selling Word Cloud Classics series and more, our extensive collection is sure to captivate and inspire readers and brighten bookshelves.A. J. Odasso’s poetry has appeared in a variety of publications, including Sybil’s Garage, Mythic Delirium, Midnight Echo, Not One of Us, Dreams & Nightmares, Goblin Fruit, Strange Horizons, Stone Telling, Farrago’s Wainscot, Liminality, Battersea Review, Barking Sycamores, and New England Review of Books. A.J.’s debut collection, Lost Books (Flipped Eye Publishing), was nominated for the 2010 London New Poetry Award and was also a finalist for the 2010–11 People’s Book Prize. Her second collection with Flipped Eye, The Dishonesty of Dreams, was released in 2014; her third collection, Things Being What They Are, was shortlisted for the 2017 Sexton Prize. She holds an MFA in creative writing from Boston University, and works in the Honors College at the University of New Mexico. A.J. has served in the Poetry Department at Strange Horizons since 2012. She lives in Albuquerque, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canterbury Classics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?015cb39c